<div fxLayoutAlign="center">
  <span [attr.color]="issueColor" class="dot"></span>
</div>
